import React from 'react'

import { TextareaProps } from '../../../types'

import { TextareaContainer } from './styles'

const Textarea = ({
  width,
  height,
  type,
  min,
  max,
  name,
  id,
  placeholder,
  value,
  defaultValue,
  inputClass,
  onChange,
  onBlur,
  onFocus,
  onClick,
  readOnly,
}: TextareaProps) => {
  return (
    <TextareaContainer
      width={width}
      type={type}
      min={min}
      max={max}
      name={name}
      id={id}
      placeholder={placeholder}
      value={value && value}
      className={inputClass}
      onChange={onChange}
      onBlur={onBlur}
      height={height}
      defaultValue={defaultValue}
      onFocus={onFocus}
      disabled={readOnly}
      onClick={onClick}
    />
  )
}

export default Textarea
